import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import { CallMessageContentViewModel } from './CallMessageContentViewModel'
import CallPrompt from 'messaging/calling/views/CallPrompt'
import styles from './CallMessageContent.sass'

interface CallMessageContentProps {
  vm: CallMessageContentViewModel
  'data-test'?: string
}

/**
 * The CallMessageContent
 */
export default observer(function CallMessageContent({
  vm: { call },
  'data-test': dataTest,
}: CallMessageContentProps) {
  return (
    <div className={cx(styles.root)} data-test={dataTest}>
      <div className={styles.text}>Call</div>
      <div className={styles.prompt}>
        <CallPrompt bordered viewToggle call={call} />
      </div>
    </div>
  )
})
